export enum ButtonId {
    ITEMS_ADD_LABELS_BUTTON = "ITEMS_ADD_LABELS_BUTTON",
    ITEMS_DELETE_LABELS_BUTTON = "ITEMS_DELETE_LABELS_BUTTON",
    ITEMS_UPDATE_LABELS_BUTTON = "ITEMS_UPDATE_LABELS_BUTTON",
}
